/**
 * @generated SignedSource<<1fc5ba0a74fd86e817ab750b80e876e0>>
 * @relayHash 7a1bfc49f9a59ae7e7d72fd7c5fe68ab
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6ba1f8a6129e441e1363c07795db1e8bb1fa9cd203853876d471fa33fae0716b

import type { ConcreteRequest, Query } from 'relay-runtime';
export type GraphIntegrationDirectoryItemType = "ACTION" | "MCP_SERVER" | "MCP_TOOL" | "SKILL" | "%future added value";
export type GraphIntegrationSkillColor = "BLUE" | "DEFAULT" | "GRAY" | "GREEN" | "LIME" | "MAGENTA" | "ORANGE" | "PURPLE" | "RED" | "TEAL" | "YELLOW" | "%future added value";
export type GraphIntegrationSurface = "AUTOMATION" | "POLLINATOR" | "ROVO" | "STUDIO" | "%future added value";
export type composableEditorChat_GetDirectoryItemsQuery$variables = {
  after?: string | null | undefined;
  cloudId: string;
  dimensionIds?: ReadonlyArray<string> | null | undefined;
  first?: number | null | undefined;
  relevantFor: ReadonlyArray<GraphIntegrationDirectoryItemType>;
  searchKeyword?: string | null | undefined;
  shouldFetch?: boolean | null | undefined;
  surface?: GraphIntegrationSurface | null | undefined;
};
export type composableEditorChat_GetDirectoryItemsQuery$data = {
  readonly graphIntegration_componentDirectoryItems?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "GraphIntegrationSkillDirectoryItem";
        readonly color: GraphIntegrationSkillColor | null | undefined;
        readonly description: string | null | undefined;
        readonly iconUrl: string | null | undefined;
        readonly id: string;
        readonly integrationKey: {
          readonly displayName: string;
          readonly iconUrl: string | null | undefined;
        } | null | undefined;
        readonly name: string;
        readonly slashCommand: string | null | undefined;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null | undefined;
    }>;
    readonly error: {
      readonly extensions: ReadonlyArray<{
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      }> | null | undefined;
      readonly message: string | null | undefined;
    } | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
      readonly startCursor: string | null | undefined;
    };
  } | null | undefined;
};
export type composableEditorChat_GetDirectoryItemsQuery = {
  response: composableEditorChat_GetDirectoryItemsQuery$data;
  variables: composableEditorChat_GetDirectoryItemsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dimensionIds"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "relevantFor"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchKeyword"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "shouldFetch"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "surface"
},
v8 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "dimensionIds",
    "variableName": "dimensionIds"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "relevantFor",
    "variableName": "relevantFor"
  },
  {
    "kind": "Variable",
    "name": "searchKeyword",
    "variableName": "searchKeyword"
  },
  {
    "kind": "Variable",
    "name": "surface",
    "variableName": "surface"
  }
],
v9 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v10 = {
  "kind": "ScalarField",
  "name": "id"
},
v11 = {
  "kind": "ScalarField",
  "name": "slashCommand"
},
v12 = {
  "kind": "ScalarField",
  "name": "name"
},
v13 = {
  "kind": "ScalarField",
  "name": "description"
},
v14 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v15 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v16 = {
  "kind": "ScalarField",
  "name": "color"
},
v17 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    },
    {
      "kind": "ScalarField",
      "name": "hasPreviousPage"
    },
    {
      "kind": "ScalarField",
      "name": "startCursor"
    },
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v18 = {
  "kind": "ScalarField",
  "name": "message"
},
v19 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v20 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v21 = [
  (v10/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "name": "composableEditorChat_GetDirectoryItemsQuery",
    "selections": [
      {
        "condition": "shouldFetch",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v8/*: any*/),
            "concreteType": "GraphIntegrationDirectoryItemConnection",
            "kind": "LinkedField",
            "name": "graphIntegration_componentDirectoryItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphIntegrationDirectoryItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          {
                            "concreteType": "GraphIntegrationDirectoryFilterDimension",
                            "kind": "LinkedField",
                            "name": "integrationKey",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              (v14/*: any*/)
                            ]
                          },
                          (v16/*: any*/)
                        ],
                        "type": "GraphIntegrationSkillDirectoryItem"
                      }
                    ]
                  }
                ]
              },
              (v17/*: any*/),
              {
                "concreteType": "QueryError",
                "kind": "LinkedField",
                "name": "error",
                "plural": false,
                "selections": [
                  (v18/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                      (v19/*: any*/),
                      (v20/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "composableEditorChat_GetDirectoryItemsQuery",
    "selections": [
      {
        "condition": "shouldFetch",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v8/*: any*/),
            "concreteType": "GraphIntegrationDirectoryItemConnection",
            "kind": "LinkedField",
            "name": "graphIntegration_componentDirectoryItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphIntegrationDirectoryItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          {
                            "concreteType": "GraphIntegrationDirectoryFilterDimension",
                            "kind": "LinkedField",
                            "name": "integrationKey",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              (v14/*: any*/),
                              (v10/*: any*/)
                            ]
                          },
                          (v16/*: any*/)
                        ],
                        "type": "GraphIntegrationSkillDirectoryItem"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v21/*: any*/),
                        "type": "GraphIntegrationActionDirectoryItem"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v21/*: any*/),
                        "type": "GraphIntegrationMcpServer"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v21/*: any*/),
                        "type": "GraphIntegrationMcpTool"
                      }
                    ]
                  }
                ]
              },
              (v17/*: any*/),
              {
                "concreteType": "QueryError",
                "kind": "LinkedField",
                "name": "error",
                "plural": false,
                "selections": [
                  (v18/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "6ba1f8a6129e441e1363c07795db1e8bb1fa9cd203853876d471fa33fae0716b",
    "metadata": {},
    "name": "composableEditorChat_GetDirectoryItemsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "4a689406810ab9a3713f9c74a94febbd";

export default node;
